<ng-template #defaultTemplate let-height="height" let-option="option" let-campaign="campaign" let-event="event"
             let-raised="raised">
  <div class="current-campaign" [ngStyle]="{'max-height.px': height }">
    <div class="event-info-wrapper campaign-image">
      <img class="event-image" [src]="getImageUrl(event)"/>
    </div>

    <div class="event-info-wrapper" *ngIf="isNotEmpty(event)">
      <div class="title-text">Event</div>
      <div class="current-name-text"> {{ event.name }} </div>
    </div>

    <div class="event-info-wrapper progress-wrapper">
      <app-progress-line></app-progress-line>
    </div>

  </div>
</ng-template>

<ng-template #auctionTemplate let-height="height" let-option="option" let-campaign="campaign" let-event="event"
             let-raised="raised">
  <div class="current-campaign" [ngStyle]="{'max-height.px': height }">
    <app-current-auction-option [campaign]="campaign" [option]="option" [event]="event"
                                [raised]="raised"></app-current-auction-option>
    <div class="event-info-wrapper progress-wrapper">
      <app-progress-line></app-progress-line>
    </div>
  </div>
</ng-template>

<ng-template #donateTemplate class="current-campaign" let-height="height" let-option="option" let-campaign="campaign"
             let-raised="raised" let-event="event">
  <div class="current-campaign" [ngStyle]="{'max-height.px': height }">
    <app-current-campaign-option [campaign]="campaign" [option]="option" [event]="event"
                                 [raised]="raised"></app-current-campaign-option>
    <div class="event-info-wrapper progress-wrapper">
      <app-progress-line></app-progress-line>
    </div>
  </div>
</ng-template>

<ng-template #lastHeroTemplate let-campaign="campaign" let-height="height" let-option="option" let-event="event"
             let-raised="raised" let-list="list">
  <div class="current-campaign" [ngStyle]="{'max-height.px': height }">
    <app-current-last-hero-option [campaign]="campaign" [option]="option" [event]="event" [list]="list"
                                  [raised]="raised"></app-current-last-hero-option>
    <div class="event-info-wrapper progress-wrapper">
      <app-progress-line></app-progress-line>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="height$ | async as height">
  <ng-container *ngIf="event$ | async as event">
    <ng-container *ngIf="summary$ | async as summary">
      <ng-container *ngIf="campaign$ | async as campaign">
        <ng-container *ngIf="option$ | async as option">
          <ng-container *ngIf="list$ | async as list">
            <ng-container class="widget__content"
                          *ngTemplateOutlet="selectedTemplateRef; context: getContext(event, campaign, option, summary, height, list)"></ng-container>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</ng-container>

